module.exports = __webpack_public_path__ + "static/img/KH.16ccda91.svg";